import React from 'react';
interface IProps {
  className?: string;
}

const SearchIcon = ({ className = '' }: IProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <g
        id="Search"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M12.9033846,0 C20.0295385,0 25.8067692,5.77723077 25.8067692,12.9033846 C25.8067692,15.9298462 24.7569231,18.7064615 23.0129231,20.9070769 L30.7692308,28.6633846 L28.6633846,30.7692308 L20.9070769,23.0129231 C18.7064615,24.7569231 15.9298462,25.8067692 12.9033846,25.8067692 C5.77723077,25.8067692 0,20.0295385 0,12.9033846 C0,5.77723077 5.77723077,0 12.9033846,0 Z M12.9033846,2.78892308 C7.32676923,2.78892308 2.78892308,7.32553846 2.78892308,12.9033846 C2.78892308,18.48 7.32553846,23.0178462 12.9033846,23.0178462 C18.48,23.0178462 23.0178462,18.48 23.0178462,12.9033846 C23.0178462,7.32676923 18.48,2.78892308 12.9033846,2.78892308 Z"
          id="Combined-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export default SearchIcon;
